import api from './api';
import { LoginCredentials, AuthResponse, User } from '@/types';
import { AUTH_ENDPOINTS } from '@/constants/apiEndpoints';
import { logger } from '@/utils/logger';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>(AUTH_ENDPOINTS.LOGIN, {
      email: credentials.email,
      password: credentials.password,
    });
    return response.data;
  },

  loginWith2fa: async (payload: {
    email: string;
    password: string;
    totp_code?: string;
    backup_code?: string;
  }): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>(AUTH_ENDPOINTS.LOGIN_2FA, payload);
    return response.data;
  },

  loginWithOidc: async (token: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>(AUTH_ENDPOINTS.LOGIN_OIDC, { token });
    return response.data;
  },

  logout: async (): Promise<void> => {
    // Get refresh token from sessionStorage only
    const refresh_token = sessionStorage.getItem('refresh_token');

    try {
      // Call backend to invalidate tokens and destroy session
      await api.post(AUTH_ENDPOINTS.LOGOUT, {
        refresh_token: refresh_token || undefined,
      });
    } catch (error) {
      // Even if logout API call fails, still clear local tokens
      logger.error('Logout API call failed:', error);
    } finally {
      // Clear tokens from sessionStorage only
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      sessionStorage.removeItem('user');
    }
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<User>(AUTH_ENDPOINTS.ME);
    return response.data;
  },

  refreshToken: async (): Promise<AuthResponse> => {
    const refresh_token = sessionStorage.getItem('refresh_token');
    const response = await api.post<AuthResponse>(AUTH_ENDPOINTS.REFRESH, {
      refresh_token: refresh_token || undefined,
    });
    return response.data;
  },
};
